import { render, staticRenderFns } from "./PropertyHealthAlerts.vue?vue&type=template&id=262e1a02"
import script from "./PropertyHealthAlerts.vue?vue&type=script&lang=ts"
export * from "./PropertyHealthAlerts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports